export default "__VITE_ASSET__VrgPV7qB__"